import request from 'request-promise';
import Template from 'template';
import t from 'translate';
import { EventDebouncer } from 'event-debouncer';

const createNodeFromHTML = (htmlString) =>
{
	return (new DOMParser()).parseFromString(htmlString, 'text/html').body.children[0] || null;
};

const body = document.querySelector('body');

class CustomerServiceWidget
{
	/*
	#widgetWrapper = null;
	#widgetButtons = null;
	#messageContainer = null;
	
	#widgetContainer = null;
	#widgetHeader = null;
	#widgetSearchInput = null;
	#widgetSearchBtn = null;
	#widgetHeaderBackBtn = null;
	#widgetSearchSuggestions = null;
	
	#widgetTabContactInput = null;
	#widgetTabFAQInput = null;
	
	#widgetContent = null; // $('.widgetContent .tabContact');
	#widgetTabContentContact = null;
	#widgetTabContentFAQ = null;
	
	isOpen = false;
	
	#debug = true;
	
	#firstLoad = true;
	#breadcrumbs = [];
	#prevContent = []; // FIXME: rename no breadcrumbHistory
	#backLimit = 20; //limit for how many past actions are saved in prevContent
	#currentAction = null;
	isLoading = false;
	*/
	constructor(widgetWrapper, widgetButtons, messageContainer)
	{
		this.widgetWrapper = null;
		this.widgetButtons = null;
		this.messageContainer = null;
		
		this.widgetContainer = null;
		this.widgetHeader = null;
		this.widgetSearchInput = null;
		this.widgetSearchBtn = null;
		this.widgetHeaderBackBtn = null;
		this.widgetSearchSuggestions = null;
		
		this.widgetTabContactInput = null;
		this.widgetTabFAQInput = null;
		
		this.widgetContent = null;
		this.widgetTabContentContact = null;
		this.widgetTabContentFAQ = null;
		
		this.widgetMessageBtn = null;
		
		this.isOpen = false;
		
		this.debug = false;
		
		this.firstLoad = true;
		this.breadcrumbs = [];
		this.prevContent = []; // FIXME: rename no breadcrumbHistory
		this.backLimit = 20; //limit for how many past actions are saved in prevContent
		this.currentAction = null;
		this.isLoading = false;
		
		
		// TODO: verify input elements...
		
		this.widgetWrapper = widgetWrapper;
		this.widgetButtons = widgetButtons;
		this.messageContainer = messageContainer;
		
		this.widgetContainer = this.widgetWrapper.querySelector('.widgetContentContainer');
		this.widgetHeader = this.widgetContainer.querySelector('.widgetSearch');
		this.widgetHeaderBackBtn = this.widgetHeader.querySelector('.widgetBtn.left');
		
		this.widgetSearchInput = this.widgetHeader.querySelector('.search input#search');
		this.widgetSearchBtn = this.widgetHeader.querySelector('.search .searchBtn');
		this.widgetSearchSuggestions = this.widgetHeader.querySelector('.searchSuggestions');
		
		
		this.widgetTabContactInput = this.widgetContainer.querySelector('#tabContact');
		this.widgetTabFAQInput = this.widgetContainer.querySelector('#tabFaq');
		
		this.widgetContent = this.widgetContainer.querySelector('.widgetContent');
		this.widgetTabContentContact = this.widgetContent.querySelector('.tabContact');
		this.widgetTabContentFAQ = this.widgetContent.querySelector('.tabFaq');
		
		this.widgetMessageBtn = this.widgetTabContentContact.querySelector('.messageBtn');
	}
	
	init()
	{
		if(this.debug) console.log('init customerServiceWidget');
		
		for(const widgetButton of this.widgetButtons)
		{
			widgetButton.addEventListener('click', event =>
			{
				this.isOpen ? this.closeWidget() : this.openWidget();
			});
			
			widgetButton.classList.remove('hidden');
		}
		
		this.widgetContainer.addEventListener('transitionend', event =>
		{
			if(!this.isOpen) this.widgetContainer.classList.add('hidden');
		});
		
		const suggestionsDebouncer = new EventDebouncer(value => this.updateSearchSuggestions(value), 500);
		
		this.widgetSearchInput.addEventListener('keyup', event => // TODO: put input into form and listen on submit instead.
		{
			if(this.isLoading) return;
			
			if(event.key === 'Enter')
			{
				this.breadcrumbs.length = 1;
				
				this.getContent({name:t('Search'), action:'searchContentBlocks', arg:this.widgetSearchInput.value});
				
				this.widgetSearchSuggestions.classList.add('hidden');
				this.widgetSearchSuggestions.blur();
			}
			else
			{
				const hasQuery = this.widgetSearchInput.value.length >= 2;
				
				if(hasQuery) suggestionsDebouncer.event(this.widgetSearchInput.value);
				
				this.widgetSearchSuggestions.classList[hasQuery ? 'remove' : 'add']('hidden');
			}
		});
		
		this.widgetSearchBtn.addEventListener('click', event =>
		{
			if(this.isLoading) return;
			
			this.breadcrumbs.length = 1;
			
			const options =
			{
				name: t('Search'),
				action: 'searchContentBlocks',
				arg: this.widgetSearchInput.value
			};
			
			this.getContent(options);
			
			this.widgetSearchSuggestions.classList.add('hidden');
		});
		
		this.widgetHeaderBackBtn.addEventListener('click', event =>
		{
			if(this.isLoading) return;
			
			const param = this.prevContent.pop();
			
			if(this.prevContent.length === 0) this.widgetHeaderBackBtn.classList.add('hidden');
			
			this.breadcrumbs = param.breadcrumbs;
			
			this.getContent(param, true, true);
		});
		
		// this.widgetMessageBtn.addEventListener('click', async event =>
		// {
		// 	if(this.isLoading) return;
			
		// 	let data = formToObject(this.widgetTabContentContact.querySelector('form'));
			
		// 	data.action = 'sendMessage';
			
		// 	const response = await request.postURL('/customerServiceWidget', data);
			
		// 	if(response.status === 0)
		// 	{
		// 		this.widgetTabContentContact.querySelector('form').classList.add('hidden');
		// 		this.widgetTabContentContact.querySelector('.messageSentBox').classList.remove('hidden');
		// 	}
		// 	else
		// 	{
				
		// 	}
		// });
		
		this.widgetSearchInput.focus(() => this.widgetSearchInput.classList.remove('hidden'));
		
		this.widgetSearchInput.addEventListener('focusout', event =>
		{
			//clicking a search suggestion doesn't work without this as the suggestions are hidden before the click goes through
			// NOTE: check event.target instead of using timeout
			setTimeout(()=>this.widgetSearchSuggestions.classList.add('hidden'), 500);
		});
		
		this.widgetTabContactInput.addEventListener('change', event =>
		{
			if(!this.widgetTabContactInput.checked) return;
			
			for(const child of this.widgetHeader.children) child.classList.add('hidden');
			
			this.widgetHeader.querySelector('.widgetBtn.right').classList.remove('hidden');
			this.widgetHeader.querySelector('.contactText').classList.remove('hidden');
		});
		
		this.widgetTabFAQInput.addEventListener('change', event =>
		{
			if(!this.widgetTabFAQInput.checked) return;
			
			for(const child of this.widgetHeader.children) child.classList.remove('hidden');
				
			if(this.prevContent.length === 0) this.widgetHeaderBackBtn.classList.add('hidden');
			
			this.widgetHeader.querySelector('.contactText').classList.add('hidden');
		});
	}
	
	openWidget()
	{
		if(this.debug) console.debug('Showing customer service widget');
		
		if(this.firstLoad)
		{
			//jotform js was slowing down the pagespeed so i added this to avoid loading it until the widget is opened
			
			/*const jotForm = document.createElement('iframe'); //createNodeFromHTML('<iframe id="JotFormIFrame-210503735763352" title="Kontakt Med24.dk" allowtransparency="true" allowfullscreen="true" loading="lazy" src="https://form.jotform.com/210503735763352" frameborder="0" scrolling="yes"></iframe>)');
			jotForm.id = 'JotFormIFrame-210503735763352';
			jotForm.title = 'Kontakt Med24.dk';
			jotForm.allowFullscreen = true;
			jotForm.allowtransparency = true;
			jotForm.loading = 'lazy';
			jotForm.src = 'https://form.jotform.com/210503735763352';
			jotForm.frameborder = '0';
			jotForm.scrolling = 'yes';
			
			this.widgetTabContentContact.appendChild(jotForm);*/
			
			this.firstLoad = false;
			
			this.getContent({action:'getRootMenu'});
		}
		
		this.widgetContainer.classList.remove('hidden');
		this.widgetContainer.classList.add('open');
		
		const size = body.getAttribute('data-init-bs-device');
		
		body.classList[size==='xs'?'add':'remove']('noScroll');
		
		this.isOpen = true;
	}
	
	closeWidget()
	{
		if(this.debug) console.debug('Hiding customer service widget');
		
		this.widgetContainer.classList.remove('open');
		body.classList.remove('noScroll');
		
		/*this.widgetTabContentContact.querySelector('.messageSentBox').classList.add('hidden');
		this.widgetTabContentContact.querySelector('form').classList.remove('hidden');*/
		
		this.isOpen = false;
	}
	
	async getRootMenu()
	{
		if(this.debug) console.log('function getRootMenu');
		
		this.widgetHeaderBackBtn.classList.add('hidden');
		this.widgetSearchSuggestions.classList.add('hidden');
		
		this.prevContent = [];
		this.breadcrumbs =
		[{
			name:'Start',
			action:'getRootMenu',
			args:''
		}];
		
		const response = await request.postURL('/customerServiceWidget', {action:'getRootMenu'});
		
		this.widgetTabContentFAQ.querySelector('.loadingContent').remove();
		
		response.categories.forEach(category =>
		{
			const rootCategory = (new Template('rootCategory')).compile({title:category.title, icon:category.icon});
			
			rootCategory.querySelector('.icon-wrapper, .categoryLabel').addEventListener('click', event =>
			{
				if(!this.isLoading) this.getContent({name:category.title, action:'getContentBlocks', arg:category.id});
			});
			
			this.widgetTabContentFAQ.appendChild(rootCategory);
		});
		
		this.isLoading = false;
	}
	
	async getContentBlocks(categoryID)
	{
		if(this.debug) console.log('function getContentBlocks', categoryID);
		
		const response = await request.postURL('/customerServiceWidget', {action:'getContentBlocks', widgetCategoryID:categoryID});
		
		const list = document.createElement('ul');
		list.classList.add('contentBlocks');
		
		response.contentBlocks.forEach(contentBlock =>
		{
			if(this.debug) console.log('contentBlock in category', contentBlock);
			
			const contentBlockTpl = (new Template('contentBlock')).compile({title:contentBlock.title});
			
			contentBlockTpl.addEventListener('click', event =>
			{
				if(!this.isLoading) this.getContent({name:'', action:'getContentBlock', arg:contentBlock.id});
			});
			
			list.appendChild(contentBlockTpl);
		});
		
		this.widgetTabContentFAQ.querySelector('.loadingContent').remove();
		
		this.widgetTabContentFAQ.appendChild(list);
		
		this.isLoading = false;
	}
	
	async getContentBlock(contentBlockID)
	{
		if(this.debug) console.log('function getContentBlock', contentBlockID);
		
		const response = await request.postURL('/customerServiceWidget', {action:'getContentBlock', contentBlockID:contentBlockID});
		
		if(this.debug) console.log('contentBlock response', response);
		
		const content = (new Template('contentBlockContent')).compile({title:response.title});
		
		content.querySelector('.blockEditContent').innerHTML = response.content;
		
		this.widgetTabContentFAQ.querySelector('.loadingContent').remove('hidden');
		
		this.widgetTabContentFAQ.appendChild(content);
		
		this.isLoading = false;
	}
	
	async searchContentBlocks(query)
	{
		if(this.debug) console.log('function searchContentBlocks', query);
		
		const response = await request.postURL('/customerServiceWidget', {action:'searchContentBlocks', query:query});
		
		const list = document.createElement('ul');
		list.classList.add('contentBlocks');
		
		const resultText = document.createElement('div');
		resultText.classList.add('searchText');
		resultText.textContent = t('Search results for');
		
		const queryText = document.createElement('strong');
		queryText.textContent = query;
		
		resultText.appendChild(queryText);
		
		response.searchResults.forEach(result =>
		{
			const contentBlockTpl = (new Template('searchResult')).compile({title:result.title, categoryName:result.categoryName});
			
			contentBlockTpl.querySelector('p').innerHTML = result.snippet;
			
			contentBlockTpl.addEventListener('click', event =>
			{
				if(this.isLoading) return;
				
				this.breadcrumbs.length = 1;
				this.breadcrumbs.push({name:result.categoryName, action:'getContentBlocks', arg:result.categoryID});
				
				this.getContent({name:'', action:'getContentBlock', arg:result.id});
			});
			
			list.appendChild(contentBlockTpl);
		});
		
		this.widgetTabContentFAQ.querySelector('.loadingContent').remove();
		
		this.widgetTabContentFAQ.appendChild(resultText);
		this.widgetTabContentFAQ.appendChild(list);
		
		this.isLoading = false;
	}
	
	renderBreadcrumbs()
	{
		if(this.debug) console.log('function renderBreadcrumbs', this.breadcrumbs);
		
		const ol = document.createElement('ol');
		
		this.breadcrumbs.forEach((crumb, index, arr) =>
		{
			const li = document.createElement('li');
			
			if(index === arr.length - 1)
			{
				li.textContent = crumb.name;
			} 
			else
			{
				const a = document.createElement('a');
				
				a.textContent = crumb.name;
				a.addEventListener('click', event =>
				{
					if(this.isLoading) return;
						
					this.breadcrumbs.length = this.breadcrumbs.indexOf(crumb)+1;
					
					this.getContent(crumb, true);
				});
				
				li.appendChild(a);
				
				const spacer = document.createElement('span');
				spacer.innerHTML = '&gt;';
				
				li.appendChild(spacer);
			}
			
			ol.appendChild(li);
		});
		
		const breadcrumbsContaier = document.createElement('div');
		breadcrumbsContaier.classList.add('widgetBreadcrumbs');
		
		breadcrumbsContaier.appendChild(ol);
		
		this.widgetTabContentFAQ.appendChild(breadcrumbsContaier);
	}
	
	getContent(param, crumbClick, backClick)
	{
		if(this.debug) console.log('function getContent', param, crumbClick, backClick);
		
		this.isLoading = true;
		
		if(typeof backClick === 'undefined')
		{
			if(this.prevContent.length >= this.backLimit) this.prevContent.shift();
			
			this.prevContent.push(this.currentAction);
		}
		
		if(typeof crumbClick === 'undefined') this.breadcrumbs.push(param);
		
		this.currentAction = {action: param.action, arg: param.arg, breadcrumbs: this.breadcrumbs.slice()}; // slice() copying array
		
		this.widgetTabContentFAQ.innerHTML = '';
		
		if(param.action !== 'getRootMenu')
		{
			this.renderBreadcrumbs();
			
			if(this.prevContent.length !== 0) this.widgetHeaderBackBtn.classList.remove('hidden');
		}
		
		const loadingContent = document.createElement('div');
		loadingContent.classList.add('loadingContent');
		loadingContent.innerHTML = '<span class="icon"></span>';
		
		this.widgetTabContentFAQ.appendChild(loadingContent);
		
		if(param.action === 'getRootMenu') this.getRootMenu();
		else if(param.action === 'getContentBlocks') this.getContentBlocks(param.arg);
		else if(param.action === 'getContentBlock') this.getContentBlock(param.arg);
		else if(param.action === 'searchContentBlocks') this.searchContentBlocks(param.arg);
	}
	
	async updateSearchSuggestions(query)
	{
		if(this.debug) console.log('function updateSearchSuggestions', query);
		
		const response = await request.postURL('/customerServiceWidget', {action:'searchContentBlocks', query:query});
		
		const list = document.createElement('ul');
		list.classList.add('contentBlocks');
		
		response.searchResults.forEach(result =>
		{
			var contentBlockTpl = (new Template('contentBlock')).compile({title:result.title});
			
			contentBlockTpl.addEventListener('click', event =>
			{
				if(this.isLoading) return;
				
				this.breadcrumbs.length = 1;
				this.breadcrumbs.push({name:result.categoryName, action:'getContentBlocks', arg:result.categoryID});
				
				this.getContent({name:'', action:'getContentBlock', arg:result.id});
				
				this.widgetSearchSuggestions.classList.add('hidden');
			});
			
			list.appendChild(contentBlockTpl);
		});
		
		this.widgetSearchSuggestions.querySelector('.contentBlocks').replaceWith(list);
	}
}

export default CustomerServiceWidget;
